// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"63028622","453":"76cd2577","732":"f1166657","977":"5837d885"}[chunkId] + ".chunk.js";
};